var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpeed = function SvgSpeed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 16,
    height: 16,
    viewBox: "0 0 4.233 4.233",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -292.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5177",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.45,
    d: "M.478 296.3a1.89 1.89 0 0 1 .423-2.395 1.89 1.89 0 0 1 2.432 0 1.89 1.89 0 0 1 .422 2.395"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path5179",
    cx: 2.117,
    cy: 295.35,
    r: 0.397,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5185",
    fill: "currentColor",
    d: "M.467 296.17h3.316v.355H.467z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5187",
    width: 1.445,
    height: 0.45,
    x: -145.84,
    y: 256.62,
    fill: "currentColor",
    rx: 0.22,
    ry: 0.22,
    transform: "rotate(-30)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path5189",
    cx: 2.117,
    cy: 294.07,
    r: 0.198,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse5191",
    cx: 149.51,
    cy: 253.44,
    r: 0.198,
    fill: "currentColor",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse5193",
    cx: -254.72,
    cy: 148.23,
    r: 0.198,
    fill: "currentColor",
    transform: "rotate(-60)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse5195",
    cx: -145.84,
    cy: 255.56,
    r: 0.198,
    fill: "currentColor",
    transform: "rotate(-30)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse5197",
    cx: 256.84,
    cy: 144.56,
    r: 0.198,
    fill: "currentColor",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse5205",
    cx: -295.35,
    cy: 0.839,
    r: 0.198,
    fill: "currentColor",
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse5207",
    cx: 295.35,
    cy: -3.394,
    r: 0.198,
    fill: "currentColor",
    transform: "rotate(90)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpeed);
export default ForwardRef;